import React from 'react';
import {useNavigate} from 'react-router-dom';

const Message = ({notification, data}: any): any => {
  // console.log(
  //   'Pusher notification received:',
  //   notification,
  //   data?.notification,
  // );
  const navigate = useNavigate();
  const getNotificationLink = (type: number): string => {
    // console.log('parsedType', type);
    switch (type) {
      case 1:
        return 'events';
      case 2:
        return 'guests';
      case 3:
        return 'booktable';
      case 5:
        return 'restaurantbooktable';
      default:
        return 'users';
    }
  };
  return (
    <>
      <div
        onClick={() => {
          navigate(`/${getNotificationLink(notification?.type)}`);
        }}
        style={{cursor: 'pointer'}}>
        <div id="notificationHeader">
          {Boolean(notification?.image) && (
            <div id="imageContainer" className="mb-3">
              <img src={notification.image} width={100} />
            </div>
          )}
          <span>
            <b>{notification.title}</b>
          </span>
        </div>
        <div id="notificationBody">{notification.body}</div>
      </div>
    </>
  );
};

export default Message;
